import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M10.93 7.248 7.469 5.353a1.419 1.419 0 0 0-1.426.011c-.444.26-.709.722-.709 1.237V10.4c0 .515.265.977.71 1.237a1.412 1.412 0 0 0 1.419.015l3.474-1.903c.458-.257.73-.724.73-1.248 0-.525-.272-.992-.736-1.252l-.001-.001Zm-.64 1.335-3.475 1.904c-.013.006-.052.028-.098-.001-.05-.029-.05-.071-.05-.085V6.6c0-.014 0-.056.05-.085a.095.095 0 0 1 .049-.014c.024 0 .043.01.055.017l3.462 1.896c.012.008.05.029.05.087 0 .058-.038.08-.044.083v-.002ZM8 .5c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm0 14.667A6.674 6.674 0 0 1 1.333 8.5 6.674 6.674 0 0 1 8 1.833 6.674 6.674 0 0 1 14.667 8.5 6.674 6.674 0 0 1 8 15.167Z"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 .5h16v16H0z"
		})
	}) })]
});
export default SvgNew;
